import { computed, Signal } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { EntityProps, EntityState } from '@ngrx/signals/entities';
import { remove as removeDiac } from 'diacritics';

import { SelectedEntityState } from '../../../../shared/store/selected-entity.feature';
import { FamilleLivrables } from '../models/famille-livrables.model';
import { FamilleLivrablesState } from './famille-livrables.store';

type State = FamilleLivrablesState & EntityState<FamilleLivrables> & SelectedEntityState;
type Props = EntityProps<FamilleLivrables> & { selectedEntity: Signal<FamilleLivrables | null> };

export function avecSélecteursFamilleLivrables<_>() {
  return signalStoreFeature(
    {
      state: type<State>(),
      props: type<Props>(),
    },
    withComputed(({ filtre, entities }) => ({
      famillesLivrablesFiltrées: computed(() =>
        entities().filter((e) => removeDiac(e.nom.toLowerCase()).includes(removeDiac(filtre()))),
      ),
      famillesLivrablesTriées: computed(() => {
        const familles = entities();
        familles.sort((a, b) => a.nom.localeCompare(b.nom));
        return familles;
      }),
    })),
  );
}
